import Vue from "vue";
import { Geometry, Properties, Feature, LineString, point, Point } from '@turf/helpers';
import { LngLat } from "mapbox-gl";
import nearestPointOnLine from "@turf/nearest-point-on-line";


export const locationStore = Vue.observable({
	history: [] as GeolocationPosition[],
	currentTime: 0,
	trackLength: 60000,
	currentPosition: undefined as LngLat|undefined,
	currentAccuracy: 0,
	locationProgress: -1,
	distanceFromTrack: 0,
});




export function updateLocation(loc:GeolocationPosition|undefined, trackFeature:Feature<LineString, Properties>, trackLength:number):void {
	if(loc && loc["type"] == "geolocate") {
		// const last = locationStore.history.length > 0 ? locationStore.history[locationStore.history.length-1] : undefined;
		// if(last && last.coords.longitude == loc.coords.longitude && last.coords.latitude == loc.coords.latitude)
		// 	return;

		//if the accuracy i higher than this, let's say we don't know where we are.
		if(loc.coords.accuracy >= 150) {
			locationStore.currentPosition = undefined;
			return;
		}

		locationStore.history.push({coords: loc.coords, timestamp:loc.timestamp});
		locationStore.currentPosition = new LngLat(loc.coords.longitude, loc.coords.latitude);
		locationStore.currentAccuracy = loc.coords.accuracy;
		updateCurrentTime();
	}
	updateLocationProgress(trackFeature, trackLength);
}

function updateLocationProgress(trackFeature:Feature<LineString, Properties>, trackLength:number) {
	if(locationStore.currentPosition && trackFeature) {
		const pt = nearestPointOnLine(trackFeature, locationStore.currentPosition.toArray());
		locationStore.distanceFromTrack = pt.properties.dist;
		if(pt.properties.dist < 0.1) {
			locationStore.locationProgress = pt.properties.location / trackLength;
			return;
		}
	}
	locationStore.locationProgress = -1;
}

function updateCurrentTime() {
	const firstTime = locationStore.history.length > 0 ? locationStore.history[0].timestamp : 0;
	const lastTime = locationStore.history.length > 0 ? locationStore.history[locationStore.history.length-1].timestamp : 0;
	locationStore.currentTime = lastTime - firstTime;

	//trim away old positions that are no longer visible
	const h = locationStore.history.filter((item, i, arr) => {
		const next = i < arr.length-1 ? arr[i+1] : undefined;
		if(next)
			return locationStore.currentTime - next.timestamp < locationStore.trackLength;
		return true;
	});

	//opt: will not trigger update if list didn't change.
	if(locationStore.history.length != h.length)
		locationStore.history = h;
}

function tick() {
	// console.log("tick");
	updateCurrentTime();
	setTimeout(tick, 2000);
}

tick();